import { render } from "./ContactSideTab.vue?vue&type=template&id=4833051b&scoped=true"
import script from "./ContactSideTab.vue?vue&type=script&lang=js"
export * from "./ContactSideTab.vue?vue&type=script&lang=js"

import "./ContactSideTab.vue?vue&type=style&index=0&id=4833051b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4833051b"]])

export default __exports__